export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-6">关于番茄影视大全</h2>
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            番茄影视大全诞生于2020年，致力于为广大影视爱好者打造一个<strong className="text-foreground-800">完全免费、无需注册、高清流畅</strong>的在线观影平台。五年来，我们持续优化播放体验，扩充内容库，从最初的几百部剧集发展到如今超过30万部影视资源的规模。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            我们的内容覆盖国产剧、韩剧、美剧、日剧、电影、综艺、动漫、纪录片八大品类，每日同步全网最新最热的内容更新。支持手机、平板、电脑多端访问，真正做到<strong className="text-foreground-800">随时随地免费看</strong>。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            作为一家坚守初心的影视平台，番茄影视大全始终把用户体验放在首位——无广告打扰、无会员套路、不收集隐私，让每一位用户都能纯粹地享受观影的乐趣。未来，我们将继续深耕内容与体验，做你最值得信赖的免费影视伙伴。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-10">
          {[
            { num: '5年+', label: '稳定运营' },
            { num: '30万+', label: '影视资源' },
            { num: '3000万+', label: '月活跃用户' },
            { num: '99.9%', label: '服务可用率' },
          ].map((item, i) => (
            <div key={i} className="p-4 md:p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">{item.num}</div>
              <div className="text-xs md:text-sm text-foreground-500">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}